import React from "react";
import { ShapeObject } from "@shared/Map/types";

interface ShapesFactoryProps {
	shape: ShapeObject["shape"];
	objId?: string;
	color?: string;
	stroke?: string;
	strokeWidth?: number;
}

const ShapesFactory: React.FC<ShapesFactoryProps> = (props) => {
	const common = {
		"data-layerid": "shapes",
		"data-objectid": props.objId,
	};

	if (props.shape === "kill")
		return (
			<path
				{...common}
				stroke={props.stroke || "white"}
				fill={props.color}
				strokeWidth={props.strokeWidth || 0.6}
				d={
					"m 8 16.6 l 4.8 4.8 l -1.9 1.9 l 1.9 1.9 l -1.9 1.9 l -3.4 -3.4 l -3.9 3.9 l -1.9 -1.9 l 3.9 -3.9 l -3.4 -3.4 l 1.9 -1.9 l 1.9 1.9 l 1.9 -1.9 z m -5.5 -14.3 l 4.8 0 l 16.3 16.3 l 1.9 -1.9 l 1.9 1.9 l -3.4 3.4 l 3.9 3.9 l -1.9 1.9 l -3.9 -3.9 l -3.4 3.4 l -1.9 -1.9 l 1.9 -1.9 l -16.3 -16.3 z m 19.9 -0.1 l 4.8 0 l 0 4.8 l -5.7 5.7 l -4.8 -4.8 z"
				}
			></path>
		);

	if (props.shape === "minion")
		return (
			<path
				{...common}
				stroke={props.stroke || "white"}
				fill={props.color}
				strokeWidth={props.strokeWidth || 0.6}
				d="M16 30.6c1.8 0 12.8-11.4 12.8-11.4s-3.3-3.4-5.8-7.8c-3-5.3-4.1-10-7-10-2.9 0-4 4.7-7 10-2.5 4.4-5.8 7.8-5.8 7.8s11 11.4 12.8 11.4Zm0-13.5c1.4.2 4.6-4 6.1-2.6.8.8-.7 4.3-2 6.5-2.1 3.3-4.1 5.2-4.1 5.2s-2-2-4-5.2c-1.4-2.2-3-5.7-2.1-6.5 1.5-1.4 4.7 2.8 6.1 2.6Z"
			/>
		);

	if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(props.shape))
		return (
			<text
				fontStyle={"bold"}
				fill={props.color}
				stroke={props.stroke || "white"}
				strokeWidth={props.strokeWidth || 0.4}
				{...common}
				alignmentBaseline={"middle"}
				textAnchor={"middle"}
				x={16}
				y={16}
				width={32}
				height={32}
				fontSize={28}
			>
				{props.shape}
			</text>
		);

	if (props.shape === "rect")
		return (
			<rect
				stroke={props.stroke || props.color}
				strokeWidth={props.strokeWidth || 2}
				{...common}
				x={2}
				y={2}
				width={26}
				fill={"transparent"}
				height={26}
			/>
		);

	if (props.shape === "circle")
		return (
			<circle
				stroke={props.stroke || props.color}
				strokeWidth={props.strokeWidth || 2}
				fill={"transparent"}
				{...common}
				cx={15}
				cy={15}
				r={13}
			/>
		);

	if (props.shape === "cross")
		return (
			<g {...common}>
				<line
					{...common}
					stroke={props.stroke || "white"}
					strokeWidth={(props.strokeWidth || 4) + 0.6}
					x1={2}
					x2={26}
					y1={2}
					y2={26}
				/>
				<line
					{...common}
					stroke={props.stroke || "white"}
					strokeWidth={(props.strokeWidth || 4) + 0.6}
					x1={26}
					x2={2}
					y1={2}
					y2={26}
				/>
				<line
					{...common}
					stroke={props.color}
					strokeWidth={props.strokeWidth || 4}
					x1={2}
					x2={26}
					y1={2}
					y2={26}
				/>
				<line
					{...common}
					stroke={props.color}
					strokeWidth={props.strokeWidth || 4}
					x1={26}
					x2={2}
					y1={2}
					y2={26}
				/>
			</g>
		);

	return null;
};

export { ShapesFactory };
